
import { BulkImportsOverviewComponent } from '@/tax/components';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ConfirmDeactivateGuard  {
    constructor() {}

    canDeactivate(target: BulkImportsOverviewComponent) {
        return !target.isImporting();

    }
}
